const isNewsServiceName = (serviceName) => serviceName === "avNirvana" ||
    serviceName === "bluRay" ||
    serviceName === "hidefDigest" ||
    serviceName === "whySoBlu";
export default isNewsServiceName;
